import { graphql } from '../../../graphql/generated';

export const IMPORT_LOOKUP_DOCTOR_QUERY = graphql(`
  query ImportLookupDoctor {
    labs {
      id
      identifier
      name
    }
  }
`);
